import OverlayBackground from './overlay-background';

export default OverlayBackground;